export default __webpack_public_path__ + "static/media/logoBlack.65bd30f9.svg";